<template>
  <div class="exam-wrapper">
    <div class="card-header" style="display: flex; align-items: center; justify-content: space-between">
      <div class="exam-progress">
        <span class="progress-text">{{ progressText }}</span>
        <div v-for="(item, index) in totalExams"
             :key="index"
             class="exam-step-item">
          <div class="exam-circle"
               @click="setQuestion(index)"
               :class="isExamCompleted(index) ? 'completed' : 'incomplete'">
            {{ getExamLabel(index) }}
          </div>
          <span  class="marking-badge" :class="getMarkingBadgeClass(index)">
            {{ getMarkingLabel(index) }}
          </span>
        </div>
      </div>
      <div style="display: flex; align-items: center" v-if="totalExams.length > 1">
        <el-button type="info">Sau</el-button>
        <el-button type="primary">Trước</el-button>
      </div>
    </div>
    <div class="card-body exam-content">
      <div :class="['exam-tabs', typeExam === SPEAKING ? 'order-2' : 'order-1']">
        <el-tabs v-model="activeTabName" class="custom-tab-wrapper" @tab-change="handleTabChange" @tab-click="handleTabClick">
          <el-tab-pane name="checkCheating" class="tab-pane" :disabled="!unlockedTabs.includes('checkCheating') && !readonly">
            <template #label>
              <div class="tab-label">
                <span>KIỂM TRA ĐẠO VĂN</span>
              </div>
            </template>
            <CheckHasTest :didStudentDo="questionExam?.didStudentDo" @handleNotDone="handleNotDone" :isView="readonly"></CheckHasTest>
            <ExamPlagiarismCheck 
                :key="getCheckCheatingKey" 
                @nextStep="handleClick"
                @cheatingNext="handleCheatingNext"
                :cheating="questionExam?.cheating || { type: null, description: '' }" 
                :readonly="readonly" 
                :is-last-tab="false"
                :type-exam="typeExam"
                :writing-count="dataExam.length"
            />
          </el-tab-pane>
          <el-tab-pane
              v-for="group in questionExam?.items || []"
              :label="group.label.toUpperCase()"
              :name="group.key"
              :key="group.key"
              :disabled="!unlockedTabs.includes(group.key) && !readonly">
            <template #label>
              <div class="tab-label">
                <span>{{ group.label.toUpperCase() }}</span>
              </div>
            </template>
            <MarkExamForm
                :readonly="readonly"
                :group="group"
                :key="group.key"
                :is-last-tab="isLastTab"
                @go-next="handleNext"
                @go-back="handleBack"
                :templateMark="templateMark"
                :disabled="disabled"
                :isAI="questionExam?.isAI"
            />
          </el-tab-pane>
        </el-tabs>
      </div>

      <div :class="['exam-student-view', typeExam === SPEAKING ? 'order-1' : 'order-2']">
        <ExamStudentSpeaking
            :key="questionSpeakingIndex"
            v-if="typeExam === SPEAKING"
            :questions="dataExam[0]?.questions ?? []"
            :question="questionSpeaking"
            :question-speaking-index="questionSpeakingIndex"
            :readonly="readonly"
            :autoplay="!readonly"
            @questionIndex="handleChangeQuestion"
        />
        <ExamStudentWriting
            :key="questionIndex"
            v-if="typeExam === WRITING"
            :question="questionExam.questions"
        />
      </div>
    </div>
    <ConfirmNotHasTestModal @markZeroPoint="markZeroPoint" @cancel-not-have-test="cancelNotHaveTest">
    </ConfirmNotHasTestModal>
  </div>
</template>

<script>
import ExamPlagiarismCheck from "@/view/pages/marking-exam/components/ExamPlagiarismCheck.vue";
import ExamStudentSpeaking from "@/view/pages/marking-exam/components/ExamStudentSpeaking.vue";
import ExamStudentWriting from "@/view/pages/marking-exam/components/ExamStudentWriting.vue";
import MarkExamForm from "@/view/pages/marking-exam/components/MarkExamForm.vue";
import {SPEAKING, WRITING} from "@/common/courseTemplate";
import CheckHasTest from "../../classes/CheckHasTest.vue";
import ConfirmNotHasTestModal from "../../classes/ConfirmNotHasTestModal.vue";

export default {
  name: 'ExamStudentForm',
  components: {
    ExamPlagiarismCheck,
    MarkExamForm,
    ExamStudentSpeaking,
    ExamStudentWriting,
    CheckHasTest,
    ConfirmNotHasTestModal
  },
  props: {
    activeName: String,
    dataExam: {
      type: Array,
      default: () => []
    },
    readonly: Boolean,
    typeExam: Number,
    questionIndex: Number,
    unlockedTabs: {
      type: Array,
      default: () => []
    },
    templateMark:{
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      SPEAKING, WRITING,
      questionSpeakingIndex: 0,
      activeTabName: 'checkCheating',
      isLastTab: false
    }
  },
  watch: {
    activeName(){
      this.activeTabName = this.activeName
    }
  },
  computed: {
    questionExam() {
      return this.dataExam[this.questionIndex] || {}
    },
    questionSpeaking() {
      if (this.typeExam === SPEAKING) {
        return this.dataExam[0]?.questions?.[this.questionSpeakingIndex] || {}
      }
    },
    totalExams() {
      return this.typeExam === SPEAKING ? '1' : this.dataExam.length
    },
    completedExams() {
      return this.readonly ? this.totalExams : this.questionIndex
    },
    progressText() {
      return `Đã chấm hoàn thành: ${this.completedExams}/${this.totalExams} bài`
    },
    getCheckCheatingKey() {
      if (this.typeExam === WRITING) {
        return `checkCheating-writing-${this.questionIndex}`
      }
      return 'checkCheating-speaking'
    }
  },
  methods: {
    isExamCompleted(index) {
      if (this.readonly) {
        return true
      }
      return this.questionIndex > index
    },
    handleCheatingNext(cheatingData) {
      if (cheatingData && cheatingData.type === 1) {
        this.$emit('cheatingNext', cheatingData)
      } else {
        if (this.typeExam === SPEAKING) {
          this.$emit('go-next', 'checkCheating')
        } else if (
            this.typeExam === WRITING &&
            Array.isArray(this.dataExam)
        ) {
          this.$emit('go-next', 'checkCheating')
        }
      }
    },
    setQuestion(index) {
      this.$emit('handleChangeQuestion', index)
      this.$emit('resetTab')
    },
    handleTabChange(newActiveName) {
      this.$emit('update:activeName', newActiveName)
    },
    handleNext(currentKey) {
      this.$emit('go-next', currentKey)
    },
    handleBack(currentKey) {
      this.$emit('go-back', currentKey)
    },
    handleChangeQuestion(index) {
      this.$emit('handleChangeQuestion', index)
      if (index >= 0 && index < (this.dataExam[0]?.questions.length)) {
        this.questionSpeakingIndex = index
      }
    },
    handleClick(currentKey) {
      this.$emit('handleClick', currentKey)
    },
    getExamLabel(index) {
      return index + 1
    },
    getMarkingBadgeClass(index) {
      const exam = this.dataExam[index]
      return exam?.isAI ? 'badge-ai' : 'badge-admin'
    },
    getMarkingLabel(index) {
      const exam = this.dataExam[index]
      return exam?.isAI ? 'AI hỗ trợ chấm' : 'Admin chấm'
    },
    handleTabClick(tab){
      const nameTab = tab.paneName
      
      this.isLastTab = nameTab === this.questionExam?.items[this.questionExam?.items.length - 1].key
      if(nameTab === 'checkCheating'){
        this.$emit('backCheatTab')
      }
    },
    cancelNotHaveTest() {
      this.questionExam.didStudentDo.value = true
      this.$bvModal.hide("ModalConfirmNotHasTestModal")
    },
    markZeroPoint(){
      this.questionExam.items.forEach((evaluation) => {
        evaluation.comment_detail = ''
        evaluation.items.forEach((item) => {
          item.criterion_score = 0
          item.comment_auto = ''
        })
      })
      this.$emit('next-step-mark-zero')
    },
    handleNotDone(){
      this.$bvModal.show("ModalConfirmNotHasTestModal")
    },
  }
}
</script>

<style scoped>
.exam-wrapper {
  background-color: white;
  overflow: auto;
  height: calc(100vh - 58px - 96px - 80px);
}

.exam-header {
  padding: 12px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

@media (min-width: 1024px) {
  .exam-header {
    padding: 16px 32px;
  }
}

.exam-progress {
  grid-column: span 2;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 1.25rem;
}

.progress-text {
  font-weight: bold;
  font-size: 20px;
}

.exam-step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.exam-circle {
  width: 32px;
  height: 32px;
  border-radius: 9999px;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.marking-badge {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 4px;
  margin-top: 5px;
  font-weight: 500;
  white-space: nowrap;
}

.badge-ai {
  background-color: #52c41a;
  color: white;
}

.badge-admin {
  background-color: #b37feb;
  color: white;
}

.exam-circle.completed {
  background: linear-gradient(to right, #89C23B, #61A900);
}

.exam-circle.incomplete {
  background: linear-gradient(to right, #1A9CFC, #1E4DB7);
  color: white;
}

.exam-content {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

@media (min-width: 1024px) {
  .exam-content {
    grid-template-columns: repeat(5, 1fr);
  }
}

.exam-tabs {
  grid-column: span 3;
  overflow-y: auto;
}

.exam-tabs.order-1 {
  order: 1;
}

.exam-tabs.order-2 {
  order: 2;
}

.exam-student-view {
  grid-column: span 2;
  padding-left: 16px;
  padding-right: 16px;
}

.exam-student-view.order-1 {
  order: 1;
}

.exam-student-view.order-2 {
  order: 2;
}

.tab-label {
  padding-right: 10px;
}

.tab-pane {
  padding-bottom: 1rem;
}
</style>
